// extracted by mini-css-extract-plugin
module.exports = {"hotelImageThumb":"HotelImage_hotelImageThumb__2bsF3","hotelImage":"HotelImage_hotelImage__39nWX"};